import {
  QuickGuideReport,
  ChartData,
  TopVisitData,
  TopMenuData,
  TopVisitByType,
  MaterialVisitDetail,
  Export,
  AccessRateChartsData,
} from '@/domain/entities/QuickGuideReport'
import { Pagination } from '@/domain/entities/Pagination'
import { AxiosResponse } from 'axios'
import { BaseResponseMapper } from './Base'

export class QuickGuideReportDataMapper extends BaseResponseMapper {
  public convertQuickGuideReportFromApi(
    result: AxiosResponse<any>
  ): QuickGuideReport {
    const { data } = result
    return new QuickGuideReport(
      data.success,
      data.message,
      data.data.top_menu.items.map(
        (menu) =>
          new TopMenuData(menu.id, menu.name, menu.key, menu.value, menu.color)
      ),
      data.data.charts.items.map(
        (chart) =>
          new ChartData(chart.value, chart.category_id, chart.category_name)
      ),
      data.data.access_rate_charts
        ? data.data.access_rate_charts.items.map(
            (val) =>
              new AccessRateChartsData(
                val.month,
                val.percentage,
                val.total_user_access,
                val.total_user_visit
              )
          )
        : [],
      data.data.top_visit.items.map(
        (user) =>
          new TopVisitData(
            user.id,
            user.title,
            user.total_user,
            user.total_visit
          )
      ),
      data.data.top_visit_by_type.items.map(
        (type) =>
          new TopVisitByType(type.type_name, type.total_user, type.total_visits)
      ),
      data.data.material_visit_detail.items.map(
        (material) =>
          new MaterialVisitDetail(
            material.title,
            material.category,
            material.car_type,
            material.total_views,
            material.total_user_visited,
            material.id
          )
      ),
      new Pagination(
        data.data.material_visit_detail.pagination.current_page,
        data.data.material_visit_detail.pagination.page_count,
        data.data.material_visit_detail.pagination.page_size,
        data.data.material_visit_detail.pagination.row_count,
        data.data.material_visit_detail.pagination.first_row_on_page,
        data.data.material_visit_detail.pagination.last_row_on_page
      )
    )
  }
  public convertExportFileFromAPi(result: AxiosResponse<any>): Export {
    const { data } = result
    return new Export(data.success, data.message, data.data)
  }
}
